import { SentimentVeryDissatisfied } from '@mui/icons-material';
import Typography from '@mui/material/Typography';

import {
  IconWrapper,
  MessageContent,
  MessageModalBox,
} from './DeniedAccessMessageModal.styles';

export default function DeniedAccessMessageModal() {
  return (
    <MessageModalBox data-testid="denied-access-message-modal">
      <Typography id="message-modal-title" variant="h6" component="h2">
        Acesso Negado!
      </Typography>
      <MessageContent id="message-modal-description" sx={{ mt: 2 }}>
        <IconWrapper>
          <SentimentVeryDissatisfied fontSize="large" />
        </IconWrapper>
        A empresa não possui acesso ao Editor Fiscal.
      </MessageContent>
    </MessageModalBox>
  );
}
